var app = angular.module('leonardo');

var PropertyListStatusFilter = function () {
  return function (properties, status) {
    var results = [];

    angular.forEach(properties, function(property) {
      if (_.contains(status.split(','), property.progress_status.toString()))
        results.push(property);
    });

    return results;
  }
};

app.filter('propertyListStatus', [PropertyListStatusFilter]);
